import authentication from '../middleware/authentication'
const Index = () => import(/* webpackChunkName: "static/js/chunks/companySetting" */'../../views/companySetting/index')

const companyResponseRoutes = {
  path: '/company-setting',
  name: 'CompanySetting',
  component: Index,
  meta: {
    middleware: authentication,
    layout: 'main',
    pageTitle: 'クライアント管理メニュー'
  }
}

export default companyResponseRoutes
